<template>
  <div class="faqs-container">
    <el-card class="page-header-card" shadow="hover">
      <div class="page-header">
        <div class="page-title-section">
          <h2 class="page-title">
            <font-awesome-icon icon="question-circle" class="page-title-icon" />
            Түгээмэл асуулт хариулт удирдах хэсэг
          </h2>
          <p class="page-subtitle">Асуулт хариултыг үүсгэх, засах, устгах</p>
        </div>
        <el-button
          v-if="checkPermissionsPage('admin')"
          @click="createFAQsDialogOpen()"
          type="primary"
          size="large"
          class="create-button"
        >
          <font-awesome-icon icon="plus" class="button-icon" />
          Түгээмэл асуулт хариулт үүсгэх
        </el-button>
      </div>
    </el-card>

    <el-card class="table-card mt-10" shadow="hover">
      <template #header>
        <div class="table-header">
          <font-awesome-icon icon="table" class="table-header-icon" />
          <span class="table-header-title">Асуулт хариултын жагсаалт</span>
          <el-tag type="info" class="table-count-tag">{{ data.length }} асуулт</el-tag>
        </div>
      </template>
      <el-table :data="data" style="width: 100%" border class="modern-faqs-table" stripe>
              <el-table-column label="Асуулт" prop="answer"></el-table-column>
              <el-table-column label="Хариулт" prop="question"></el-table-column>
              <el-table-column label="Төлөв" prop="is_active" v-if="checkPermissionsPage('admin')">
                <template #default="scope">
                  <el-switch @change="changeStatus(scope.row)" v-model="scope.row.is_active" class="ml-2" inline-prompt style="--el-switch-on-color: #13ce66; --el-switch-off-color: #ff4949" active-text="Идэвхтэй" inactive-text="Идэвхгүй" />
                </template>
              </el-table-column>
              <el-table-column label="Үйлдэл" width="250" v-if="checkPermissionsPage('admin')" align="center">
                <template v-slot="scope">
                  <el-button-group>
                    <el-button
                      v-if="checkPermissionsPage('admin')"
                      @click="createFAQsDialogOpen(scope.row)"
                      size="small"
                      class="action-button"
                    >
                      <font-awesome-icon icon="edit" class="button-icon-small" />
                      Засварлах
                    </el-button>
                    <el-button
                      v-if="checkPermissionsPage('admin')"
                      @click="deleteRow(scope.row)"
                      type="danger"
                      size="small"
                      class="action-button"
                    >
                      <font-awesome-icon icon="trash" class="button-icon-small" />
                      Устгах
                    </el-button>
                  </el-button-group>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              @current-change="handlePageChange"
              :current-page="currentPage"
              :page-size="pageSize"
              :total="data.length"
              layout="total, prev, pager, next, jumper"
              class="modern-pagination" />
    </el-card>
    <CreateFaqsDialog :selectedFAQs="this.targetFAQs" />
  </div>
</template>
<script>
import services from '@/services'
import { ElMessage, ElMessageBox } from 'element-plus'
import { mapActions, mapGetters } from 'vuex'
import CreateFaqsDialog from './createFAQsDialog.vue'
import { checkPermissions } from '@/helpers/custom'

export default {
  name: 'UserListPage',
  components: {
    CreateFaqsDialog
  },
  created () {
    this.loadData()
  },
  data () {
    return {
      currentPage: 1,
      pageSize: 5,
      data: [],
      columns: [],
      targetFAQs: {}
    }
  },
  computed: {
    ...mapGetters([
      'cdnGetter'
    ])
  },
  methods: {
    ...mapActions(['setCreateFAQsDialog']),
    async loadData () {
      try {
        const response = await services.get('faqs')
        if (response) {
          this.data = response.data
          this.totalRecords = response.data.length
        } else {
          ElMessage.error('Өгөгдөл олдсонгүй!')
        }
      } catch (error) {
        console.error('Error fetching data: ', error)
        ElMessage.error(`Өгөгдөл ачаалахад алдаа гарлаа: ${error.message}`)
      }
    },
    checkPermissionsPage (data) {
      return checkPermissions(data)
    },
    handlePageChange (page) {
      this.currentPage = page
    },
    editRow (row) {
      console.log('Edit Row: ', row)
    },
    createFAQsDialogOpen (data) {
      this.targetFAQs = data
      this.setCreateFAQsDialog(true)
    },
    async deleteRow (row) {
      try {
        await ElMessageBox.confirm('Та энэ бичлэгийг устгахдаа итгэлтэй байна уу?', 'Баталгаажуулалт', {
          confirmButtonText: 'Тийм',
          cancelButtonText: 'Үгүй',
          type: 'warning'
        })
        await services.delete('faqs', row.id)
        this.loadData()
        ElMessage.success('Амжилттай устгагдлаа!')
        const index = this.data.indexOf(row)
        if (index > -1) {
          this.data.splice(index, 1)
        }
      } catch (error) {
        if (error !== 'cancel') {
          ElMessage.error('Устгахад алдаа гарлаа!')
        }
      }
    },
    async changeStatus (data) {
      try {
        const response = await services.update('faqs', data)
        if (response && response.data) {
          ElMessage.success('Төлөв амжилттай өөрчлөгдлөө!')
        }
      } catch (error) {
        console.error('Aldaa: ', error.message)
        this.$message.error(error.message)
      }
    }
  }
}

</script>
  <style lang="scss" scoped>
/* FAQs Container */
.faqs-container {
  padding: 0;
}

/* Page Header Card */
.page-header-card {
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  border: none;
  margin-bottom: 24px;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}

.page-title-section {
  flex: 1;
}

.page-title {
  font-size: 28px;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 8px 0;
  display: flex;
  align-items: center;
  gap: 12px;
}

.page-title-icon {
  color: #667eea;
  font-size: 32px;
}

.page-subtitle {
  font-size: 14px;
  color: #6b7280;
  margin: 0;
}

.create-button {
  border-radius: 8px;
  padding: 12px 24px;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
  transition: all 0.3s ease;
}

.create-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);
}

.button-icon {
  margin-right: 8px;
}

/* Table Card */
.table-card {
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  border: none;
}

.table-header {
  display: flex;
  align-items: center;
  gap: 12px;
}

.table-header-icon {
  color: #667eea;
  font-size: 20px;
}

.table-header-title {
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  flex: 1;
}

.table-count-tag {
  border-radius: 20px;
  padding: 4px 12px;
}

/* Modern FAQs Table */
.modern-faqs-table {
  border-radius: 8px;
  overflow: hidden;
}

.modern-faqs-table :deep(.el-table__header) {
  background: #f9fafb;
}

.modern-faqs-table :deep(.el-table__header th) {
  background: #f9fafb;
  color: #374151;
  font-weight: 600;
  border-bottom: 2px solid #e5e7eb;
  padding: 16px 0;
}

.modern-faqs-table :deep(.el-table__body tr:hover) {
  background: #f3f4f6;
}

.modern-faqs-table :deep(.el-table__body td) {
  padding: 16px 0;
}

/* Action Buttons */
.action-button {
  border-radius: 6px;
  transition: all 0.2s ease;
}

.action-button:hover {
  transform: translateY(-1px);
}

.button-icon-small {
  margin-right: 4px;
  font-size: 12px;
}

/* Pagination */
.modern-pagination {
  margin-top: 24px;
  display: flex;
  justify-content: flex-end;
}

/* Responsive */
@media (max-width: 768px) {
  .page-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .page-title {
    font-size: 24px;
  }

  .action-button {
    margin-bottom: 4px;
    font-size: 11px;
    padding: 6px 8px;
  }

  .button-icon-small {
    display: none;
  }

  /* Mobile Table Scroll */
  .table-card {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .modern-faqs-table {
    min-width: 600px;
  }
}

@media (max-width: 480px) {
  .page-title {
    font-size: 20px;
  }

  .create-button {
    width: 100%;
    margin-top: 8px;
  }
}
</style>
